/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Which activity types are available to hub owners
 * @export
 * @interface SurfaceGameEnabledActivityTypes
 */
export interface SurfaceGameEnabledActivityTypes {
    /**
     * Whether hub owners can create leaderboards for this game
     * @type {boolean}
     * @memberof SurfaceGameEnabledActivityTypes
     */
    leaderboards?: boolean;
    /**
     * Whether hub owners can create challenges for this game
     * @type {boolean}
     * @memberof SurfaceGameEnabledActivityTypes
     */
    challenges?: boolean;
    /**
     * Whether hub owners can create tournaments for this game
     * @type {boolean}
     * @memberof SurfaceGameEnabledActivityTypes
     */
    tournaments?: boolean;
    /**
     * Whether hub owners can create missions for this game
     * @type {boolean}
     * @memberof SurfaceGameEnabledActivityTypes
     */
    missions?: boolean;
}

/**
 * Check if a given object implements the SurfaceGameEnabledActivityTypes interface.
 */
export function instanceOfSurfaceGameEnabledActivityTypes(value: object): value is SurfaceGameEnabledActivityTypes {
    return true;
}

export function SurfaceGameEnabledActivityTypesFromJSON(json: any): SurfaceGameEnabledActivityTypes {
    return SurfaceGameEnabledActivityTypesFromJSONTyped(json, false);
}

export function SurfaceGameEnabledActivityTypesFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfaceGameEnabledActivityTypes {
    if (json == null) {
        return json;
    }
    return {
        
        'leaderboards': json['leaderboards'] == null ? undefined : json['leaderboards'],
        'challenges': json['challenges'] == null ? undefined : json['challenges'],
        'tournaments': json['tournaments'] == null ? undefined : json['tournaments'],
        'missions': json['missions'] == null ? undefined : json['missions'],
    };
}

export function SurfaceGameEnabledActivityTypesToJSON(json: any): SurfaceGameEnabledActivityTypes {
    return SurfaceGameEnabledActivityTypesToJSONTyped(json, false);
}

export function SurfaceGameEnabledActivityTypesToJSONTyped(value?: SurfaceGameEnabledActivityTypes | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'leaderboards': value['leaderboards'],
        'challenges': value['challenges'],
        'tournaments': value['tournaments'],
        'missions': value['missions'],
    };
}

